/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './communication-log.reducer';

export const CommunicationLog = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const communicationLogList = useAppSelector(state => state.communicationLog.entities);
  const loading = useAppSelector(state => state.communicationLog.loading);
  const totalItems = useAppSelector(state => state.communicationLog.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="communication-log-heading" data-cy="CommunicationLogHeading">
        <Translate contentKey="tinyMedicRestApp.communicationLog.home.title">Communication Logs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.communicationLog.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/communication-log/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.communicationLog.home.createLabel">Create new Communication Log</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.communicationLog.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {communicationLogList && communicationLogList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('recepient')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.recepient">Recepient</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('recepient')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('noOfRetries')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.noOfRetries">No Of Retries</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('noOfRetries')} />
                </th>
                <th className="hand" onClick={sort('requestURI')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.requestURI">Request URI</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('requestURI')} />
                </th>
                <th className="hand" onClick={sort('requestMsg')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.requestMsg">Request Msg</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('requestMsg')} />
                </th>
                <th className="hand" onClick={sort('requestStartTime')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.requestStartTime">Request Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('requestStartTime')} />
                </th>
                <th className="hand" onClick={sort('responseStartTime')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.responseStartTime">Response Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('responseStartTime')} />
                </th>
                <th className="hand" onClick={sort('responseCode')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.responseCode">Response Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('responseCode')} />
                </th>
                <th className="hand" onClick={sort('responseMsg')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.responseMsg">Response Msg</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('responseMsg')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('eventName')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.eventName">Event Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('eventName')} />
                </th>
                <th className="hand" onClick={sort('operationType')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.operationType">Operation Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('operationType')} />
                </th>
                <th className="hand" onClick={sort('tenantId')}>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.tenantId">Tenant Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tenantId')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.channel">Channel</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.communicationLog.template">Template</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {communicationLogList.map((communicationLog, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/communication-log/${communicationLog.id}`} color="link" size="sm">
                      {communicationLog.id}
                    </Button>
                  </td>
                  <td>{communicationLog.recepient}</td>
                  <td>{communicationLog.status}</td>
                  <td>{communicationLog.noOfRetries}</td>
                  <td>{communicationLog.requestURI}</td>
                  <td>{communicationLog.requestMsg}</td>
                  <td>{communicationLog.requestStartTime}</td>
                  <td>{communicationLog.responseStartTime}</td>
                  <td>{communicationLog.responseCode}</td>
                  <td>{communicationLog.responseMsg}</td>
                  <td>{communicationLog.active ? 'true' : 'false'}</td>
                  <td>{communicationLog.cursor}</td>
                  <td>{communicationLog.lastUpdated}</td>
                  <td>{communicationLog.microSec}</td>
                  <td>{communicationLog.timestampEntry}</td>
                  <td>{communicationLog.eventName}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.OperationType.${communicationLog.operationType}`} />
                  </td>
                  <td>{communicationLog.tenantId}</td>
                  <td>
                    {communicationLog.channel ? (
                      <Link to={`/tenant-integration-channel/${communicationLog.channel.id}`}>{communicationLog.channel.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {communicationLog.template ? (
                      <Link to={`/tenant-integration-template/${communicationLog.template.id}`}>{communicationLog.template.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/communication-log/${communicationLog.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/communication-log/${communicationLog.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/communication-log/${communicationLog.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.communicationLog.home.notFound">No Communication Logs found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={communicationLogList && communicationLogList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default CommunicationLog;
